<div class="line-item-links">
  <div *ngIf="loading">
    <li *ngFor="let dummySection of [0, 1, 2, 3, 4]">
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </li>
  </div>
  <div *ngIf="!loading">
    <div *ngFor="let obj of linksObj">
      <div>{{ obj.header }}</div>
      <ul>
        <li class="link-item" *ngFor="let link of obj.links">
          <a
            href="{{ link.hyperlink }}"
            target="_blank"
            (click)="linkClick()"
            >{{ link.linkText }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</div>
